'use strict';

export default (function () {
  var projectPageSidebar = document.querySelector('.single-project .sidebar');

  if (projectPageSidebar) {
    var projectPageContent = document.querySelector('.content');
    var projectPageContentCoords = projectPageContent.getBoundingClientRect();
    var scrollToTop;

    var initStickySidebar = function initStickySidebar() {
      if (window.innerWidth > 768) {
        scrollToTop = window.pageYOffset || document.documentElement.scrollTop;
        projectPageContentCoords = projectPageContent.getBoundingClientRect();

        if (scrollToTop > projectPageContentCoords.top) {
          projectPageSidebar.classList.add('sidebar--sticky');

          if (projectPageContentCoords.height + projectPageContentCoords.top <= projectPageSidebar.getBoundingClientRect().height + 60) {
            projectPageSidebar.classList.add('sidebar--absolute');
          } else {
            projectPageSidebar.classList.remove('sidebar--absolute');
          }
        } else {
          projectPageSidebar.classList.remove('sidebar--sticky');
        }
      } else {
        projectPageSidebar.classList.remove('sidebar--absolute');
        projectPageSidebar.classList.remove('sidebar--sticky');
      }
    };

    initStickySidebar();
    window.addEventListener('scroll', function () {
      initStickySidebar();
    });
    window.addEventListener('resize', function () {
      initStickySidebar();
    });
  }
});